import { fetchBaseQuery } from '@reduxjs/toolkit/query/react';

const azureBaseQuery = fetchBaseQuery({
  // no baseUrl here
  // entire url provided by the B/E
  // thank you Jatinder
  prepareHeaders: (headers) => {
    headers.set('x-ms-blob-type', 'BlockBlob');
    return headers;
  },
});

export default azureBaseQuery;
